module.exports = __webpack_public_path__ + "static/media/loading.1484576a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AudienceBuilder/assets/loading.svg
// module id = 2194
// module chunks = 0